import { createSelector } from '@reduxjs/toolkit';

import { ApplicationState } from 'types/store';

const selectState = (state: ApplicationState) => state.application;

// export const selectBluebookFilter = createSelector(selectState, ({ bluebookFilter }) => bluebookFilter);
export const selectFilter = createSelector(selectState, ({ filter }) => filter);
export const selectMaxDataPoints = createSelector(selectState, ({ maxDataPoints }) => maxDataPoints);

export const selectMaxRfmGroups = createSelector(selectState, ({ maxRfmGroups }) => maxRfmGroups);

export const selectMaxVisible = createSelector(selectState, ({ maxVisible }) => maxVisible);

export const selectMyAudiences = createSelector(selectState, ({ myAudiences }) => myAudiences);

export const selectMyLists = createSelector(selectState, ({ myLists }) => myLists);

export const selectMyMasterFiles = createSelector(selectState, ({ myMasterFiles }) => myMasterFiles);

export const selectMyNlsOrders = createSelector(selectState, ({ myNlsOrders }) => myNlsOrders);

export const selectMyPrebuilts = createSelector(selectState, ({ myPrebuilts }) => myPrebuilts);

export const selectNotificationUnreadOnly = createSelector(
  selectState,
  ({ notificationUnreadOnly }) => notificationUnreadOnly
);

export const selectPasswordRules = createSelector(selectState, ({ passwordRules }) => passwordRules);

export const selectPasswordRuleDescriptions = createSelector(selectPasswordRules, (rules) => {
  return rules.map(({ description }) => description);
});
